
import React from 'react'


export default function Ecoimpacts() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                    <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Economic impacts</h4><br></br>
                    </div>
                    
                    <div>
                      <p>The annual cost of invasive plants to Antiguan and Barbudan agriculture is an estimated $4M XCD <span className='tb_bottom'> (Dr. J. Gore-Francis, personal communication,  October 16,2019)</span> through yield losses and product contamination.  Agricultural invasives compete with crops and affect quality and yield of produce. They reduce the carrying capacity of pastures and can poison or cause injury to livestock or contaminate fibre. In all cases their control increases the cost of production. Some water weeds, such asWater Hyacinth (Eichhornia crassipes) degrade the quality of waterways which then impacts on agriculture, groundwater stock, aquifers, surface water catchments, thereby affecting our water reserves for life.Additionally, invasive species affect the economy, the impact environmental services, cause health implications,increase fire risk and damage infrastructure.
</p>
                    </div>
                    
                </div>
            </div>
        </div>
    </section>
  )
}

